import { useCallback } from 'react';
import { FR_EVENT_DETAILS_SUB_PATH, FR_EVENT_ROOT_PATH } from '../../router/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { FrEventDetailsTab } from '../types';

export function useOpenFrEventDetails(): (
    eventId?: number,
    frEventDetailsTabName?: FrEventDetailsTab,
    state?: Record<string, unknown>
) => void {
    const navigate = useNavigate();
    const location = useLocation();

    return useCallback(
        (eventId?: number, frEventDetailsTabName?: FrEventDetailsTab, state = {}) => {
            navigate(`${FR_EVENT_ROOT_PATH}/${eventId}/${FR_EVENT_DETAILS_SUB_PATH}`, {
                state: { ...location.state, ...state, frEventDetailsTabName },
                // Prevents new history records from being created when navigating between Event Details tabs.
                // Ensures that the Back button will take the user to the previous page, not the previous tab.
                replace: location.pathname.includes(FR_EVENT_DETAILS_SUB_PATH),
            });
        },
        [location, navigate]
    );
}
